/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DecideAgentRunMcpApprovalRequest = {
  agentId: string;
  runId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  decideAgentRunMcpApprovalRequest: components.DecideAgentRunMcpApprovalRequest;
};

/** @internal */
export const DecideAgentRunMcpApprovalRequest$inboundSchema: z.ZodType<
  DecideAgentRunMcpApprovalRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  run_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  DecideAgentRunMcpApprovalRequest:
    components.DecideAgentRunMcpApprovalRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "run_id": "runId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "DecideAgentRunMcpApprovalRequest": "decideAgentRunMcpApprovalRequest",
  });
});
/** @internal */
export type DecideAgentRunMcpApprovalRequest$Outbound = {
  agent_id: string;
  run_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  DecideAgentRunMcpApprovalRequest:
    components.DecideAgentRunMcpApprovalRequest$Outbound;
};

/** @internal */
export const DecideAgentRunMcpApprovalRequest$outboundSchema: z.ZodType<
  DecideAgentRunMcpApprovalRequest$Outbound,
  z.ZodTypeDef,
  DecideAgentRunMcpApprovalRequest
> = z.object({
  agentId: z.string(),
  runId: z.string(),
  xOnBehalfOf: z.string().optional(),
  decideAgentRunMcpApprovalRequest:
    components.DecideAgentRunMcpApprovalRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    runId: "run_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    decideAgentRunMcpApprovalRequest: "DecideAgentRunMcpApprovalRequest",
  });
});

export function decideAgentRunMcpApprovalRequestToJSON(
  decideAgentRunMcpApprovalRequest: DecideAgentRunMcpApprovalRequest,
): string {
  return JSON.stringify(
    DecideAgentRunMcpApprovalRequest$outboundSchema.parse(
      decideAgentRunMcpApprovalRequest,
    ),
  );
}
export function decideAgentRunMcpApprovalRequestFromJSON(
  jsonString: string,
): SafeParseResult<DecideAgentRunMcpApprovalRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DecideAgentRunMcpApprovalRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DecideAgentRunMcpApprovalRequest' from JSON`,
  );
}
